import { faker } from '@faker-js/faker';
import type { TemplateResourceListResponseV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { PathParams, HttpRequestResolverExtras, ResponseResolverInfo } from 'msw';
import { HttpResponse } from 'msw';
import { generateTemplateResourceReadV2Api } from './common';
import { getTemplateIdByIndex, NUMBER_TEMPLATES_PARAMETER_SETS } from './commonUuids';

export function initialGetApplicationVersionTemplatesByApplicationIdCustomHandler(): TemplateResourceListResponseV2Api {
  const numberOfItems = NUMBER_TEMPLATES_PARAMETER_SETS;

  return {
    pagination: {
      itemsPerPage: 100,
      startIndex: 0,
      totalResults: numberOfItems,
    },
    data: faker.helpers.multiple(
      (_, index) =>
        generateTemplateResourceReadV2Api({
          id: getTemplateIdByIndex(index),
        }),
      { count: numberOfItems },
    ),
  };
}

// eslint-disable-next-line max-lines-per-function
export function getApplicationVersionTemplatesByApplicationIdCustomHandler(
  context: ResponseResolverInfo<HttpRequestResolverExtras<PathParams>>,
) {
  const url = new URL(context.request.url);
  const isModuleId = url.pathname.includes('d0e8e8e0-1b4d-4336-99b8-548e08b05802');
  return HttpResponse.json<TemplateResourceListResponseV2Api>({
    pagination: {
      itemsPerPage: 10,
      startIndex: 0,
      totalResults: 2,
    },
    data: [
      {
        type: 'TEMPLATE',
        checksum: '1e234c5b-cf9a-4c98-915f-cb96085a5821',
        mimeType: 'application/vnd.apple.installer+xml',
        size: 4736,
        fileName: 'lively.oga',
        extension: 'oga',
        id: isModuleId ? '11111111-1b4d-4336-99b8-548e08b05777' : 'd0e8e8e0-1b4d-4336-99b8-548e08b05777',
        name: 'sortitus',
        creationDate: new Date('2024-12-17T17:37:28.477Z'),
        componentType: 'OTHER',
        createdBy: 'baf4f219-87f1-4bb7-af08-6fe788951602',
        description: 'Id advenio suus comedo copiose consectetur temeritas bene speculum.',
        targetLocation: '/var/log/eek.otf',
        templateFileId: '23fccac9-0682-469f-9e01-6b3b437a86f2',
        templateFileName: 'sans_truly_yet.jar',
        templateFileVersion: '1.2.4',
      },
      {
        type: 'SW_PACKAGE',
        checksum: '01640332-1805-41f2-8f09-8c3f1797d202',
        mimeType: 'application/x-sh',
        size: 8628,
        fileName: 'around_indeed_patiently.ttf',
        extension: 'ttf',
        id: isModuleId ? '22222222-1b4d-4336-99b8-548e08b05777' : 'd0e8e8e0-1b4d-4336-99b8-548e08b05666',
        name: 'utrum',
        creationDate: new Date('2024-09-30T03:53:45.152Z'),
        componentType: 'OTHER',
        createdBy: '2cf00cb6-6c86-4da6-bdc4-c04eb629db7b',
        description: 'Cohaero quam aestas vestrum admoneo iusto.',
        targetLocation: '/usr/local/src/mammoth_suckle.gif',
        templateFileId: 'bec8649d-17eb-4fb2-8a7b-40758117beb2',
        templateFileName: 'classic_unless.ifb',
        templateFileVersion: '1.2.3',
      },
      {
        type: 'SW_PACKAGE',
        checksum: '01640332-1805-41f2-8f09-8c3f1797d202',
        mimeType: 'application/x-sh',
        size: 6767,
        fileName: 'around_indeed_patiently.ttf',
        extension: 'ttf',
        id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05777',
        name: 'adhjre',
        creationDate: new Date('2024-09-30T03:53:45.152Z'),
        componentType: 'OTHER',
        createdBy: '2cf00cb6-6c86-4da6-bdc4-c04eb629db7b',
        description: 'Cohaero quam aestas vestrum admoneo iusto.',
        targetLocation: '/usr/local/src/mammoth_suckle.gif',
        templateFileId: 'bec8649d-17eb-4fb2-8a7b-40758117beb2',
        templateFileName: 'classic_unless.ifb',
        templateFileVersion: '1.2.3',
      },
    ],
  });
}
